import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map, tap, catchError } from 'rxjs/operators';
import { Observable, throwError } from 'rxjs';
import { BASE_URL } from '../../config/config';
import { NgxSpinnerService } from "ngx-spinner";
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})

export class MasterdataService { 
  public DASBOARD_URL = BASE_URL.URL;
  private userId: any;

  constructor(private http: HttpClient, private spinnerService: NgxSpinnerService, private route: Router) { }

  getMasterBodyParts(search: string = "",currentPage: number): Observable<any> {
    this.spinnerService.show();
    let token = localStorage.getItem('token');

    return this.http.get(`${this.DASBOARD_URL}/body_parts?search=${search}&page=${currentPage}`, {
      headers: {
        'Authorization': 'Bearer ' + token
      }
    })
      .pipe(
        map((res: any) => {
          return res
        }),
        tap(err => this.spinnerService.hide()),
        catchError(this.handleError.bind(this))
      );
  }

  getMasterImplants(search: string = "",currentPage: number): Observable<any> {
    this.spinnerService.show();
    let token = localStorage.getItem('token');

    return this.http.get(`${this.DASBOARD_URL}/implants?search=${search}&page=${currentPage}`, {
      headers: {
        'Authorization': 'Bearer ' + token
      }
    })
      .pipe(
        map((res: any) => {
          return res
        }),
        tap(err => this.spinnerService.hide()),
        catchError(this.handleError.bind(this))
      );
  }

  getMasterProductCategory(search: string = "",currentPage: number): Observable<any> {
    this.spinnerService.show();
    let token = localStorage.getItem('token');

    return this.http.get(`${this.DASBOARD_URL}/product_categories?search=${search}&page=${currentPage}`, {
      headers: {
        'Authorization': 'Bearer ' + token
      }
    })
      .pipe(
        map((res: any) => {
          return res 
        }),
        tap(err => this.spinnerService.hide()),
        catchError(this.handleError.bind(this))
      );
  }

  getMasterProducts(search: string = "",currentPage: number): Observable<any> {
    this.spinnerService.show();
    let token = localStorage.getItem('token');

    return this.http.get(`${this.DASBOARD_URL}/products?search=${search}&page=${currentPage}`, {
      headers: {
        'Authorization': 'Bearer ' + token
      }
    })
      .pipe(
        map((res: any) => {
          return res
        }),
        tap(err => this.spinnerService.hide()),
        catchError(this.handleError.bind(this))
      );
  }

  getMasterRegions(search: string = "",currentPage: number): Observable<any> {
    this.spinnerService.show();
    let token = localStorage.getItem('token');

    return this.http.get(`${this.DASBOARD_URL}/regions?search=${search}&page=${currentPage}`, {
      headers: {
        'Authorization': 'Bearer ' + token
      }
    })
      .pipe(
        map((res: any) => {
          return res
        }),
        tap(err => this.spinnerService.hide()),
        catchError(this.handleError.bind(this))
      );
  }

  getMasterCountry(search: string = "",currentPage: number): Observable<any> {
    this.spinnerService.show();
    let token = localStorage.getItem('token');

    return this.http.get(`${this.DASBOARD_URL}/countries?search=${search}&page=${currentPage}`, {
      headers: {
        'Authorization': 'Bearer ' + token
      }
    })
      .pipe(
        map((res: any) => {
          return res
        }),
        tap(err => this.spinnerService.hide()),
        catchError(this.handleError.bind(this))
      );
  }

  getMasterCities(search: string = "",currentPage: number): Observable<any> {
    this.spinnerService.show();
    let token = localStorage.getItem('token');

    return this.http.get(`${this.DASBOARD_URL}/locations?search=${search}&page=${currentPage}`, {
      headers: {
        'Authorization': 'Bearer ' + token
      }
    })
      .pipe(
        map((res: any) => {
          return res
        }),
        tap(err => this.spinnerService.hide()),
        catchError(this.handleError.bind(this))
      );
  }
 
  getMasterStores(search: string = "",currentPage: number): Observable<any> {
    this.spinnerService.show();
    let token = localStorage.getItem('token');

    return this.http.get(`${this.DASBOARD_URL}/stores/index?search=${search}&page=${currentPage}`, {
      headers: {
        'Authorization': 'Bearer ' + token
      }
    })
      .pipe(
        map((res: any) => {
          return res
        }),
        tap(err => this.spinnerService.hide()),
        catchError(this.handleError.bind(this))
      );
  }

  getMasterImages(id: string): Observable<any> {
    this.spinnerService.show();
    let token = localStorage.getItem('token');

    return this.http.get(`${this.DASBOARD_URL}/files/products/${id}`, {
      headers: {
        'Authorization': 'Bearer ' + token
      }
    })
      .pipe(
        map((res: any) => {
          return res
        }),
        tap(err => this.spinnerService.hide()),
        catchError(this.handleError.bind(this))
      );
  }

  masterAddItem(type: String, data: any): Observable<any> {
    this.spinnerService.show();
    let token = localStorage.getItem('token');
    return this.http.post(`${this.DASBOARD_URL}/${type}`,data,{
      headers: {
        'Authorization': 'Bearer ' + token
      }
    })
      .pipe(
        map((res: any) => {
          return res
        }),
        tap(err => this.spinnerService.hide()),
        catchError(this.handleError.bind(this))
      );
  }

  masterAddItemWithFile(type: string, data: any): Observable<any> {
    this.spinnerService.show();

    const token = localStorage.getItem('token');
    const headers = new HttpHeaders({
      'Authorization': 'Bearer ' + token
    });

    return this.http.post(`${this.DASBOARD_URL}/${type}`, data, { headers })
      .pipe(
        tap(() => this.spinnerService.hide()),
        catchError(this.handleError.bind(this))
      );
  }


  getBodyPartsAndImplantsForProduct(id: number): Observable<any> {
    this.spinnerService.show();
    let token = localStorage.getItem('token');
  
    return this.http.get(`${this.DASBOARD_URL}/product_categories/${id}`, {
      headers: {
        'Authorization': 'Bearer ' + token
      }
    }).pipe(
      tap(() => this.spinnerService.hide()),
      catchError(this.handleError.bind(this))
    );
  }
  
  

  deleteBodyParts(id: string, type: string): Observable<any> {
    this.spinnerService.show();
    let token = localStorage.getItem('token');

    const headers = {
        'Authorization': 'Bearer ' + token
    };

    return this.http.delete(`${this.DASBOARD_URL}/${type}/${id}`,{ headers })
        .pipe(
            map((res: any) => {
                return res;
            }),
            tap(err => this.spinnerService.hide()),
            catchError(this.handleError.bind(this))
        );
  }

  deletelocations(id: string, type: string): Observable<any> {
    this.spinnerService.show();
    let token = localStorage.getItem('token');

    const headers = {
        'Authorization': 'Bearer ' + token
    };

    return this.http.delete(`${this.DASBOARD_URL}/${type}/${id}`,{ headers })
        .pipe(
            map((res: any) => {
                return res;
            }),
            tap(err => this.spinnerService.hide()),
            catchError(this.handleError.bind(this))
        );
  }

  masterEditBody(type: String,id: string, body: any): Observable<any> {
    this.spinnerService.show(); // Show spinner before making the request

    const token = localStorage.getItem('token');
    const headers = new HttpHeaders({
      'Authorization': 'Bearer ' + token
    });

    return this.http.put(`${this.DASBOARD_URL}/${type}/${id}`, body, { headers })
      .pipe(
        catchError(this.handleError.bind(this)) // Handle errors globally
      );
  } 

  masterEditBodyWithFile(type: string, id: string, body: any): Observable<any> {
    this.spinnerService.show();

    const token = localStorage.getItem('token');
    const headers = new HttpHeaders({
      'Authorization': 'Bearer ' + token
    });

    return this.http.post(`${this.DASBOARD_URL}/${type}/${id}`, body, { headers })
      .pipe(
        tap(() => this.spinnerService.hide()),
        catchError(this.handleError.bind(this))
      );
  }


  getBodyPart(id: string): Observable<any> {
    // Construct the URL for fetching the body part details based on the provided ID
    const url = `${this.DASBOARD_URL}/body_parts/${id}`;

    // Make the HTTP GET request to fetch the body part details
    return this.http.get(url);
  }

  downloadBulkUploadTemplate(type: string) {
    this.spinnerService.show();

    let token = localStorage.getItem('token');

    const link = document.createElement('a');
    document.body.appendChild(link);
    link.href = `${this.DASBOARD_URL}/bulk-stocks/template/${type}?token=${token}`;
    link.setAttribute('type', 'hidden'); 
    link.click();
    
    this.spinnerService.hide();
  }

  private handleError(error: any){
    if (error.status === 401) {
      localStorage.clear();
      this.route.navigateByUrl(`/login?redirect_link=${this.route.url}`);
      this.spinnerService.hide();
      return
    }else if(error.status === 422){
      this.spinnerService.hide();
      return throwError(()=> error);
    }
    else{
      this.spinnerService.hide();
      return throwError(()=> error);
    }

  }


}
